import { graphql, useStaticQuery } from 'gatsby';

import { Query } from 'generated/graphql';

const useGetAliases = () => {
  const { allSitePage } = useStaticQuery<Query>(
    graphql`
      {
        allSitePage(limit: 10000) {
          edges {
            node {
              path
            }
          }
        }
      }
    `
  );

  const aliases = new Set<string>();

  allSitePage.edges.forEach(({ node: { path } }) => {
    aliases.add(path);
  });

  return aliases;
};

export default useGetAliases;
